<template>
  <div style="padding: 0 10px;">
    <div style="text-align: center;" class="ft14">儿童隐私政策</div>
    <div class="ft15">发布日期：2022年11月14日</div>
    <div class="ft14">欢迎使用厦门亲禾教育科技有限公司（以下简称“亲禾”“本公司”或“我们”）提供的亲小禾产品服务。我们法定注册地址为：厦门市软件园二期望海路63号之二302单元50。</div>
    <div class="ft14">我们非常重视儿童（指未满14周岁的未成年人，以下或称“孩子”）的隐私权。我们深知儿童个人信息的重要性，并采取相应保护措施，致力于保护儿童的个人信息安全可控，特按照相关法律法规要求制定本隐私政策（以下简称“本政策”)。</div>
    <div class="ft16">儿童监护人特别说明</div>
    <div class="ft14">如果您是儿童的监护人，请您在使用“亲小禾”产品服务前，仔细阅读和选择是否同意本政策。我们希望请您与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不向任何网络产品服务提供者提供任何个人信息，保护儿童个人信息安全。</div>
    <div class="ft16">儿童特别说明</div>
    <div class="ft14">如果您是儿童，您需要和您的监护人一起仔细阅读本政策，并在征得您的监护人同意后，使用亲小禾产品服务。</div>
    <div class="ft14">本政策旨在向儿童及其监护人说明，在使用亲小禾产品服务时，我们如何收集、使用、共享、存储、管理和保护儿童的信息（包括个人信息）以及提供的访问、更新、控制和保护这些信息的方式。</div>
    <div class="ft14">
      本政策适用于所有亲禾旗下需要用户输入姓名、年龄、生日等能识别相关主体年龄的产品服务（以下简称“亲小禾产品服务”)。针对不能识别或不主动识别相关主体年龄的亲小禾产品服务，适用
      <span class="ft13">《亲小禾隐私政策》</span>
      （以下简称“主隐私政策”)。本政策是主隐私政策的一部分，属于针对儿童个人信息制定的特别规则，与主隐私政策如有不一致之处，以本政策为准；本政策未载明之处，参考适用主隐私政策。
    </div>
    <div class="ft14">请务必仔细阅读并充分理解本政策，请儿童及其监护人特别关注：</div>
    <div class="ft14">1．使用<span class="ft13">加粗</span>与斜体相结合显著标识的内容，表示这些属于儿童的敏感个人信息或权限信息。</div>
    <div class="ft14">1．使用<span class="ft13">加粗</span>与<span class="ft12">下划线</span>相结合显著标识的内容，表示这些内容需要儿童及其监护人特别关注或重点注意。</div>
    <div class="ft14 ft12">一旦开始使用亲小禾产品服务，即表示儿童及其监护人已经充分理解儿童并同意本政策。如儿童或其监护人不同意本政策、请立即停止使用亲小禾产品服务。如对规则或相关事宜有任何问题，您可以通过我们的儿童个人信息保护负责人邮箱【xiamenqinheeducation@xiaohebook.com】与我们取得联系，我们会在收到联系信息后的15个工作日内完成身份核查和处理响应。</div>
    <div class="ft16">以下隐私政策正文将帮助儿童及其监护人了解以下内容：</div>
    <div class="ft16">一、我们如何收集和使用儿童的个人信息</div>
    <div class="ft16">二、我们如何共享、转移、公开披露儿童的个人信息</div>
    <div class="ft16">三、我们如何保存和保护儿童的个人信息</div>
    <div class="ft16">四、儿童及其监护人如何管理儿童的个人信息</div>
    <div class="ft16">五、行为约束</div>
    <div class="ft16">六、适用法律</div>
    <div class="ft16">七、政策更新</div>
    <div class="ft16">八、如何联系我们</div>
    <div class="ft16">一、我们如何收集和使用儿童的个人信息</div>
    <div class="ft14">我们在向儿童及其监护人提供产品服务时，将在法律允许的范围内收集儿童的个人信息和用户信息。如果儿童及其监护人不提供以下信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务的效果。除主隐私政策所述，我们还会在如下场景中收集儿童的对应个人信息：</div>
    <div class="ft16">1．验证手机号码</div>
    <div class="ft14">在您开启我们的服务以及在使用我们的服务过程中，经过您单独同意，我们可能会收集您的手机号码信息，用于对您账号和身份进行验证。</div>
    <div class="ft16">2．编辑个人资料</div>
    <div class="ft14">在您使用我们的服务过程中，为向您展示您孩子的形象，我们会收集您孩子的姓名（必填）、昵称（选填）、性别（必填）、生日（必填），用于您进行登记和查询使用。</div>
    <div class="ft14">我们提供的与儿童有关的服务是不断更新和发展的，如您选择使用《隐私政策》及本政策中尚未涵盖的其他服务，基于因所提供的服务而需要收集其他儿童个人信息的，我们会通过页面提示、交互流程、协议约定的方式另行说明信息收集的范围、目的与用途，并征得您单独同意。</div>
    <div class="ft16">二、我们如何共享、转移、公开披露儿童的个人信息</div>
    <div class="ft16">（一）共享</div>
    <div class="ft14">除我们主动收集的个人信息外，您通过亲小禾识别的绘本信息的记录（以下简称“此类信息”)，我们仅作为数据存储于服务器，按照《网络安全法》《个人信息保护法》及其他法律法规、监管政策要求，我们不会将您的此类信息收集后用于其他商业目的或分享，但当符合国家相关法律法规及其政策要求或国家有权监管部门的要求时，我们会在法律允许的范围内提供或使用您的此类信息，包括检索、筛选您的此类信息中是否存在不符合法律、法规、违反公序良俗等情形的内容，并向国家相关部门提交涉嫌违反相关法律法规规定的信息。</div>
    <div class="ft14">我们不会向其他个人信息处理者提供您的个人信息。在部分情况下，当我们将向其他第三方个人信息处理者提供您的个人信息，会以【弹窗、页面内说明、协议内说明等】方式向您告知在单个场景下涉及到的接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得您的单独同意。</div>
    <div class="ft14">请您注意，在使用第三方服务的过程中，第三方对儿童个人信息的处理将适用该第三方服务商或对应社交平台的儿童个人信息保护规则。特别提醒您，请注意查看对方社交网络或第三方合作方服务提供商的隐私政策以及儿童个人信息保护规则，以了解他们如何处理儿童个人信息，以便审慎决策。</div>
    <div class="ft16">（二）转移</div>
    <div class="ft14">原则上我们不会将您或您孩子的个人信息向其他公司、组织或个人进行转移。如因合并、分立、解散、被宣告破产等原因确需转移，我们将向您告知接收方的名称或者姓名和联系方式，并要求接收方继续履行个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，我们将要求其依照法律规定重新取得您的同意。</div>
    <div class="ft14">对我们与之转让您或您孩子个人信息的公司、组织和个人，我们会对其进行安全评估，与其签署严格的安全与保密协议，要求他们按照本声明以及其他任何相关的保密和安全措施来处理儿童个人信息。</div>
    <div class="ft16">（三）公开披露</div>
    <div class="ft14">我们不会公开我们所处理的您或您孩子的个人信息，除非取得您的单独同意。 特别地，您理解并同意，我们的产品服务中的识别绘本，可能会让第三方观看到您或您孩子的信息。</div>
    <div class="ft16">三、我们如何保存和保护儿童的个人信息</div>
    <div class="ft16">（一）保存地域</div>
    <div class="ft14">我们依照法律法规的规定，将儿童的个人信息存储于中华人民共和国境内，目前，我们不会将上述信息传输至境外。</div>
    <div class="ft16">（二）保存期限</div>
    <div class="ft14">当我们的产品服务发生停止运营的情形或儿童的个人信息存储期限届满时，我们将采取例如，推送通知、公告等形式通知儿童及其监护人，并在立即删除或匿名化处理儿童的个人信息。 如果您注销账号或主动删除本声明以及亲禾《隐私政策》所述的任何信息，除非《网络安全法》《个人信息保护法》《儿童个人信息网络保护规定》等法律法规另有保存您孩子个人信息的规定，在您注销账号或主动删除信息后，我们将对您或您孩子的个人信息进行删除。</div>
    <div class="ft16">（三）保护方式</div>
    <div class="ft14">1．为保障您孩子的信息安全，我们会在现有技术水平下努力采取合理必要的物理、技术和行政管理方面的安全措施来保护您孩子的信息，以防止您孩子的信息遭受违法复制、丢失、误用、非授权访问、下载、披露和更改，包括但不限于SSL、信息加密存储、数据中心的访问控制、专用的网络通道及代理。</div>
    <div class="ft14">2．我们建立专门的管理度、流程、组织并采取相应措施确保信息安全。对于工作人员，我们将以最小授权为原则，严格设定信息访问权限，控制儿童个人信息的知悉范围。如需访问儿童个人信息，我们将要求经过儿童个人信息保护负责人或其授权的管理人员审批，并对访问情况进行记录。此外，我们对可能接触到您孩子个人信息的员工或外包人员进行严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施；组织对员工的数据安全或合规培训等。</div>
    <div class="ft14">3．我们提醒您注意，互联网并非绝对安全的环境，当您或您的孩子通过社交软件与其他用户交互信息时，不确定第三方软件对您的孩子的信息传递是否完全加密，为保护您的孩子的个人信息安全，我们建议您和您的孩子不要通过此类方式发送您孩子的个人信息，以免个人信息泄露。请使用复杂密码，协助我们保证您孩子的账号以及个人信息安全。</div>
    <div class="ft14">4．我们也请您理解，在互联网行业由于技术的限制和飞速发展以及可能存在的各种恶意攻击手段，即便我们竭尽所能加强安全措施，也不可能始终保证信息的百分之百安全。请您了解，您孩子使用我们的产品服务时所用的系统和通讯网络，有可能在我们控制之外的其他环节而出现安全问题，请您严格监督并管理孩子的上网行为。</div>
    <div class="ft14">5．若我们确认发生个人信息泄露等安全事件，我们会立即启动应急预案，采取补救措施，阻止安全事件扩大，如涉及您孩子的个人信息，我们会将事件相关情况以邮件、信函、电话、推送通知等方式向您告知；如难以逐一告知，我们会采取公告的形式发布相关警示信息。同时，我们还将按照监管部门要求上报个人信息安全事件的处置情况。</div>
    <div class="ft16">（四）安全事件通知</div>
    <div class="ft14">1．我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。</div>
    <div class="ft14">2．个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，组成紧急应急小组，在最短时间内追溯原因并减少损失。</div>
    <div class="ft14">3. 在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您及您的孩子的补救措施等。我们将及时将事件相关情况以站内通知、短信通知、电话或邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</div>
    <div class="ft16">四、儿童及其监护人如何管理儿童的个人信息</div>
    <div class="ft14">按照中国相关的法律、法规、国家标准，我们保障经您同意后，由您对孩子个人信息行使以下权利：访问、变更您的孩子的个人信息，改变您的授权同意的范围，删除您孩子的个人信息，对处理您孩子的个人信息的行为进行限制，对您孩子的个人信息进行查阅与复制。 对于上述权利，您可以按照主隐私政策当中的您如何管理您的个人信息一节进行操作。同时，我们为儿童设立了专门负责数据及隐私保护的小组，您也可以通过本政策第8节所述方式联系我们。</div>
    <div class="ft14"><span class="ft13">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份及亲子关系。</span>我们可能会在验证身份后，然后再处理您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</div>
    <div class="ft16">五、行为约束</div>
    <div class="ft14">为保护儿童的隐私与安全，在包含其他儿童像的功能模块上若进行截图、屏幕录制行为，我们将进行软件功能上的干预，包括但不限于对截图与屏幕录制影像进行非可视化处理、限制账号登录。</div>
    <div class="ft16">六、适用法律</div>
    <div class="ft14">本政策，包括但不限于本政策的订立、效力、解释、履行和争议解决，均应适用中华人民共和国大陆地区法律（不包括香港特别行政区、澳门特别行政区与台湾地区法律）。</div>
    <div class="ft16">七、政策更新</div>
    <div class="ft14">儿童及其监护人理解并同意，我们根据法律法规或者我们的商业决策相应更新本政策，儿童及其监护人愿意受修订后政策的约束。如果涉及本政策重大变更，我们将以公告或者信息推送方式做出。</div>
    <div class="ft14">本政策所指的重大变更包括但不限于：</div>
    <div class="ft14">1．我们的产品服务模式发生重大变化。如处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等；</div>
    <div class="ft14">2．我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div>
    <div class="ft14">3.个人信息共享、转移或公开披露的主要对象发生变化；</div>
    <div class="ft14">4．您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
    <div class="ft14">5．我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div>
    <div class="ft14">6．个人信息安全影响评估报告表明存在高风险时。</div>
    <div class="ft14">
      我们还会将本政策的旧版本存档，供您查阅。
      <br>为给您带来更好的产品服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们更新本政策，并将通过弹窗、页面提示方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您单独同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过本政策第8节所述方式联系我们，我们会在收到联系信息后的15个工作日内完成身份核查和响应处理。
    </div>
    <div class="ft16">八、如何联系我们</div>
    <div class="ft14">如儿童及其监护人对本政策内容有任何疑问，请通过以下方式与我们联系：(1)儿童个人信息保护负责人电子邮箱：xiamenqinheeducation@xiaohebook.com;(2）邮寄方式：福建省厦门市集美区软件园三期B区19栋22楼（361001）;(3）电话：18046218090。我们会在收到联系信息后的15个工作日内完成身份核查和响应处理。
    </div>
    <div class="ft14">如儿童及其监护人对我们的回复不满意或者是儿童及其监护人认为我们对儿童个人信息的处理行为损害了儿童的合法权益，还可以向履行个人信息保护职责的部门进行投诉、举报。</div>


  </div>
</template>

<script>
export default {
  name: "AgreementChildrenPrivacy"
}
</script>

<style scoped>
.ft12{
  text-decoration: underline;
}

.ft13{
  font-weight: 700;
}

.ft14{
  font-size: 14px;
  margin-bottom: 10px;
}

.ft15{
  text-align: right;
  font-size: 14px;
  margin: 0 10px 10px 0;
}

.ft16 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}
</style>
